import { CustomerPaymentHistory } from "../../../model/payments/payments";
import styles from './AdminCustomerDetailsPage.module.scss';
import { formatDate } from "../../../utils";

interface LoanRepaymentDetailsProps {
	data: CustomerPaymentHistory[];
}
const LoanRepaymentDetails: React.FC<LoanRepaymentDetailsProps> = ({ data }) => {
	return (
		<div>
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>AMOUNT PAID BACK</th>
							<th>DATE OF REPAYMENT</th>
							<th>PAYMENT METHOD</th>
							<th>PAYMENT REFERENCE</th>
							<th>STATUS</th>
						</tr>
					</thead>
					<tbody>
						{data?.map((order, index) => {
							return (
								<tr key={index}>
									<td>₦ {order?.amount?.toLocaleString()}</td>
									<td>{formatDate(order?.dateOfPayment)}</td>
									<td>{order?.type}</td>
									<td>{order?.reference}</td>
									<td>{order.status}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default LoanRepaymentDetails;
